import styled from 'styled-components';

export const StyledArrowButton = styled.button`
  box-sizing: border-box;
  margin: 5px;
  padding: 20px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: none;
  color: white;
  background: #333;
  font-family: Pixel, Arial, Helvetica, sans-serif;
  font-size: 1rem;
  outline: none;
  cursor: pointer;
`